import axios from '../axios';

export default class Walmart {
    static async getCredentials() {
        return await axios.get('api/walmart/credentials');
    }

    static async createCredential(data) {
        return await axios.post('api/walmart/credentials', data);
    }

    static async testConnection(data) {
        return await axios.post('api/walmart/test-connection', data);
    }

    static async toggleActive(id) {
        return await axios.patch(`api/walmart/credentials/${id}/toggle-active`);
    }

    static async deleteCredential(id) {
        return await axios.delete(`api/walmart/credentials/${id}`);
    }

    static async importPublications(credentialId) {
        return await axios.post(`api/walmart/publications/import/${credentialId}`);
    }

    static async syncOrders(credentialId) {
        return await axios.post(`api/walmart/orders/sync/${credentialId}`);
    }

    static async syncInventory(credentialId) {
        return await axios.post(`api/walmart/inventory/sync/${credentialId}`);
    }
}
